const LogoMark = ({ size = 34, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle
      cx="34"
      cy="30"
      r="21"
      stroke="#C8A66A"
      strokeWidth="1"
      strokeDasharray="116 16"
      strokeLinecap="round"
      transform="rotate(-32 34 30)"
      opacity="0.9"
    />
    <circle cx="52.4" cy="19.5" r="2.2" fill="#EAD9B0" />
    <text
      x="20"
      y="42"
      fontFamily="Cormorant Garamond, Georgia, serif"
      fontSize="30"
      fill="#F3F0EA"
    >
      R
    </text>
  </svg>
);

export default LogoMark;
